import { Badge } from '@/components/Badge';
import Icon from '@/components/Icon/Icon';
import { HStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { type ContractStatus, getContractStatusBadgeVariant, getContractStatusIconName } from './utils';
interface BaseContractStatusBadgeProps {
  status: ContractStatus;
  statusLabel: string;
}
interface WithIconProps extends BaseContractStatusBadgeProps {
  showIcon: true;
}
interface WithoutIconProps extends BaseContractStatusBadgeProps {
  showIcon?: false;
}
type ContractStatusBadgeProps = WithIconProps | WithoutIconProps;
export const ContractStatusBadge = ({
  status,
  statusLabel,
  showIcon = false
}: ContractStatusBadgeProps) => {
  const variant = getContractStatusBadgeVariant(status);
  const content = showIcon ? <HStack className="gap-1">
      <Icon iconName={getContractStatusIconName(status)} inheritColor />
      <Text variant="badgeLabel">{statusLabel}</Text>
    </HStack> : <Text variant="badgeLabel">{statusLabel}</Text>;
  return <Badge variant={variant}>{content}</Badge>;
};

// 型定義をエクスポート
export type { ContractStatus };